import { forwardRef } from "react";
import styled from "styled-components";
import { LocalParticipant, RemoteParticipant, VideoTrack } from "twilio-video";
import { useLocalParticipant } from "../../hooks/useLocalParticipant";
import { useRoom } from "../../hooks/useRoom";
import FocusIndicator from "../FocusIndicator/FocusIndicator";
import RemoteParticipantOptions from "../RemoteParticipantOptions/RemoteParticipantOptions";
import VideoInfo from "../VideoInfo/VideoInfo";
import VideoOffIndicator from "../VideoOffIndicator/VideoOffIndicator";
import { Video, VideoWrapper } from "./Participant.styles";

const ParticipantVideoWrapper = styled(VideoWrapper)`
  && {
    height: 160px;
  }
`;

interface IParticipantVideoProps {
  isLocalParticipant: boolean;
  hide: boolean;
  isVideoOff: boolean;
  isAudioOff: boolean;
  isFrontFacing: boolean;
  participant: RemoteParticipant | LocalParticipant;
  cameraTrack: VideoTrack | undefined;
}

const ParticipantVideo = forwardRef<HTMLVideoElement, IParticipantVideoProps>(
  (
    {
      isLocalParticipant,
      isVideoOff,
      isAudioOff,
      isFrontFacing,
      participant,
      cameraTrack,
      hide,
    },
    videoRef
  ) => {
    const { handleChangeFocused } = useRoom();
    const { audioOff, videoOff } = useLocalParticipant();

    // Alterar foco camera participantes
    const handleFocused = (value: "local" | "remote") => {
      if (cameraTrack) {
        handleChangeFocused(value, cameraTrack);
      }
    };

    return (
      <ParticipantVideoWrapper elevation={12} hidden={hide}>
        <Video
          id={!isLocalParticipant ? "remote-video" : ""}
          hidden={isLocalParticipant ? videoOff : isVideoOff}
          ref={videoRef}
          style={isFrontFacing ? { transform: "scaleX(-1)" } : {}}
          autoPlay
          playsInline
          disablePictureInPicture
          muted
        />

        {(isLocalParticipant ? videoOff : isVideoOff) && <VideoOffIndicator />}

        {/* Ícone para sinalizar possibilidade de aumentar câmera do usuário */}
        <FocusIndicator
          handleChangeFocused={() =>
            handleFocused(isLocalParticipant ? "local" : "remote")
          }
          show={true}
        />

        <VideoInfo
          name={
            isLocalParticipant
              ? "Você"
              : participant.identity.split("-").slice(1, -1).join("-")
          }
          videoType={isLocalParticipant ? "local" : "remote"}
          isAudioOff={isLocalParticipant ? audioOff : isAudioOff}
        />

        {/* Opções participante-remoto */}
        {!isLocalParticipant && <RemoteParticipantOptions />}
      </ParticipantVideoWrapper>
    );
  }
);

export default ParticipantVideo;
